import {IBaseSchema} from '../base.schema';
import {IContactDetails} from '../contact-details';
import {IDemography} from '../demographics/demographics';
import {ISelectItem} from '../drop-down';
import {ICenterSelect} from './center';
import {IEntitySelect} from './entity';
import {IRole} from './role';

export interface ICenterRoles {
    center: ICenterSelect;
    roles: IRole[];
}

export interface ICredential {
    version: number;
    lastPassword: string;
    passwordUpdatedAt: Date;
    updatedAt: Date;
}

export enum ClearanceStatus {
    Expired = 'Expired',
    Complete = 'Complete',
    Pending = 'Pending',
}

export enum UserStatus {
    REGISTERED = 'REGISTERED',
    ACTIVE = 'ACTIVE',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    INACTIVE = 'INACTIVE',
    CREATED = 'CREATED',
}

export interface ITimeSlot {
    _id?: string;
    startTime: string;
    endTime: string;
    sun?: boolean;
    mon?: boolean;
    tue?: boolean;
    wed?: boolean;
    thu?: boolean;
    fri?: boolean;
    sat?: boolean;
}

export interface IUserExperience {
    type: string;
    subtype: string;
    onGoing: number;
    completed: number;
    spentHours: [
        {
            action: string;
            hours: number;
        }
    ];
}

export interface IActivityStatistics {
    totalOnGoing: number;
    totalCompleted: number;
    totalHours: number;
    experienceAsUser: IUserExperience[];
    experienceAsParticipant: IUserExperience[];
}

export interface IPreferences {
    otherLanguage?: ISelectItem[];
    communityRepresentation?: ISelectItem[];
}

export interface IEducation extends IBaseSchema {
    title: string;
    entity?: IEntitySelect;
    educationType: ISelectItem;
    description?: string;
    duration?: number;
    startDate: Date;
    endDate: Date;
}

export interface ISecurityClearance extends IBaseSchema {
    entity: IEntitySelect;
    submittedDate: Date;
    receivedDate?: Date;
    validPeriod?: ISelectItem;
    nextDueDate?: Date;
    // Volunteer Orientation
    orientationStatus: ISelectItem;
    orientationDate?: Date;
    location?: ISelectItem;
    duration?: string;
    clearanceStatus: ClearanceStatus;
}

export interface IUser extends IBaseSchema {
    /**
     * Calculated name
     */
    name?: string;

    firstName: string;

    lastName: string;

    middleInitials?: string;

    title?: string;

    email: string;

    description?: string;

    password?: string;

    credential?: ICredential;

    contact?: IContactDetails;

    demography?: IDemography;

    centerRoles: ICenterRoles[];

    status: UserStatus;

    /**
     * Basic Mediation
     */
    mediationCompleted: boolean;
    entity?: IEntitySelect | null;
    hours?: number;
    mediationBeginDate?: Date;
    mediationEndDate?: Date;
    mentoringCompleted: boolean;

    staff: boolean;
    attorney: boolean;
    boardMember?: boolean;
    fullTime: boolean;
    availableTimeSlots?: ITimeSlot[];

    preferences?: IPreferences;

    activityStatistics?: IActivityStatistics;
    educations?: IEducation[];
    securityClearance?: ISecurityClearance[];
    loginAttempts?: number;
}

export type IUserCreate = Omit<IUser, '_id'>;
export interface IUserCreated extends IUser {
    _id: string;
}

export type IUserActivate = Pick<IUser, '_id' | 'active'>;

export interface IUserTable extends Pick<IUser, 'active'> {
    _id: string;
    name: string;
    email: string;
}

export interface IUserSelect extends Pick<IUser, '_id' | 'mediationCompleted' | 'staff' | 'email'> {
    name: string;
    roles: ISelectItem[];
    rate: number;
    rateType: ISelectItem;
    duration: number;
}

export interface IUserActivitySearch {
    centers: string[];
    endDate: Date;
    startDate: Date;
    userId: string;
}

export interface IUserActivitySummary {
    closedCount: number;
    id: string;
    openStatusCount: number;
    pendingCount: number;
    type: string;
}
